import type { Folder } from "../../my_newsletters/types";
import { getContext, setContext } from "svelte";
import { writable, Writable } from "svelte/store";

const CONTEXT_KEY = {};

interface StoreProps {
  folders?: Folder[];
  activeFolder?: Folder;
  showingAddToFolder?: boolean;
  showingRestoreToFolder?: boolean;
  newsletterId?: string;
}

interface FoldersInfoStore extends Writable<StoreProps> {
  showAddToFolder(newsletterId: string): void;
  hideAddToFolder(): void;
  showRestoreToFolder(newsletterId: string): void;
  hideRestoreToFolder(): void;
  setFolders(folders: Folder[]): void;
  setActiveFolder(activeFolder: Folder): void;
}

export function getFoldersInfo() {
  const foldersInfo = getContext(CONTEXT_KEY);
  if (!foldersInfo) {
    return;
  }

  return foldersInfo as FoldersInfoStore;
}

export function setFoldersInfo(folderInfo: {}): FoldersInfoStore {
  const store = createStore(folderInfo);
  setContext(CONTEXT_KEY, store);
  return store;
}

function createStore(foldersInfo: StoreProps): FoldersInfoStore {
  const store = writable<StoreProps>(foldersInfo);
  return {
    subscribe: store.subscribe,
    set: store.set,
    update: store.update,
    showAddToFolder(newsletterId) {
      store.update((value) => ({
        ...value,
        showingAddToFolder: true,
        showingRestoreToFolder: false,
        newsletterId
      }));
    },
    hideAddToFolder() {
      store.update((value) => ({
        ...value,
        showingAddToFolder: false
      }));
    },
    showRestoreToFolder(newsletterId) {
      store.update((value) => ({
        ...value,
        showingRestoreToFolder: true,
        showingAddToFolder: false,
        newsletterId
      }));
    },
    hideRestoreToFolder() {
      store.update((value) => ({
        ...value,
        showingRestoreToFolder: false
      }));
    },
    setFolders(folders: Folder[]) {
      store.update((value) => {
        return {
          ...value,
          folders
        };
      });
    },
    setActiveFolder(activeFolder: Folder) {
      store.update((value) => {
        return {
          ...value,
          activeFolder
        };
      });
    }
  };
}
